import { useState } from "react";
import { Box, Text } from "@storyofams/react-ui";
import { createClient } from "@supabase/supabase-js";
import { useShopify } from "~context";
import { showToast } from "~lib";
import { ProductByHandleQuery } from "~lib/shopify/sdk";
import { withB2B } from "~lib/withB2B";

import { OptionSelector } from "./OptionSelector";
import { VariantSelection } from "./VariantSelection";

interface Props {
  story: any;
  product: ProductByHandleQuery["productByHandle"];
  id?: string;
  title?: string;
}

export const CustomerDivider = withB2B(
  ({ product, story, id = "", title = "" }: Props) => {
    const [pickedOption, setPickedOption] = useState(null);
    const setOption = (value) => setPickedOption(value);
    const { customer } = useShopify();
    const clickContactHandle = async () => {
      const supabase = createClient(
        process.env.NEXT_PUBLIC_SUPABASE_URL,
        process.env.NEXT_PUBLIC_SUPABASE_KEY
      );
      try {
        (window as any).GorgiasChat.open();
        const { error } = await supabase.from("wholesale_prod_req").insert({
          product_id: id,
          product_title: title,
          user_email: customer?.emailAddress?.emailAddress,
        });
        if (error) throw new Error();
        else showToast("Verzoek verzonden", "success");
      } catch {
        showToast("Error", "error");
      }
    };
    if (!product)
      return (
        <Box
          borderRadius={"md"}
          bg="#CF63631A"
          p="20px 20px 20px 40px"
          my={2}
          position={"relative"}
          border={"1px solid #CF6363"}
        >
          {" "}
          Dit product staat nog niet vermeld voor groothandel. Neem{" "}
          <Text
            onClick={clickContactHandle}
            display={"inline"}
            fontWeight={"bold"}
            textDecoration={"underline"}
            cursor={"pointer"}
          >
            {"contact"}
          </Text>{" "}
          op met ons ondersteuningsteam als u het wilt kopen.
          <Text
            top="12px"
            left="23px"
            fontWeight={"bold"}
            fontSize={"26px"}
            color="#CF6363"
            position="absolute"
          >
            !
          </Text>
        </Box>
      );
    return (
      <Box>
        <OptionSelector product={product} setPickedOption={setOption} />
        <VariantSelection
          content={story?.content}
          pickedOption={pickedOption}
          isUpsellDisabled={story?.content.isUpsellDisabled}
          product={product}
          mb={["20px", "30px"]}
        />
      </Box>
    );
  }
);
